import { styled } from '@mui/material';

import { getButtonStyles } from '../Button/Button.styles';

export const Label = styled('span')(({ theme }) => ({
  ...getButtonStyles(theme),
  height: '48px',
  fontSize: '14px',
  lineHeight: '48px',
  letterSpacing: '1px',
  textTransform: 'uppercase',
  backgroundColor: theme.palette.color.global.card,
  padding: '0 16px',

  [theme.breakpoints.down('2xl')]: {
    height: '38px',
    fontSize: '10px',
    lineHeight: '38px',
  },
  [theme.breakpoints.down('lg')]: {
    height: '34px',
    lineHeight: '34px',
  },
}));
